import Navbar from "../../Components/Navbar";
import React from "react";
import { Send } from "react-feather";
import Siderbar from "../../Components/Sidebar";
import { TableData } from "../../Components/Private/Dashboard/DashComponent/TableData";
import Select from "react-select";
import FabAdd from "../../Components/FabAdd/FabAdd";


import DeletePopUP from "../../Components/CommonPopUp/DeletePopUp";
import ApprovedPopUp from "./Approved Popup/ApprovedPopUp";


export default function MemberCardGenerated() {
  const [showAddPopUp, setshowAddPopUp] = React.useState(false);
  const [deletePopUpShow, setdeletePopUpShow] = React.useState(false);
  const [deleteRecord, setdeleteRecord] = React.useState(false);
  const [isopen, setIsOpen] = React.useState(false);
  const [popupflag, setpopupflag] = React.useState("");

  const toggle = () => {
    setIsOpen(!isopen);
  };
  const handleOnAddClick = () => {
    setshowAddPopUp(true);
    setpopupflag("ADD");
  };

  const handleOnUpdateClick = () => {
    setshowAddPopUp(true);
    setpopupflag("UPDATE");
  };

  const handelClosePopUpClick = () => {
    setshowAddPopUp(false);
  };

  const handelDeleteDesignation = (item) => {
    // setflag("Delete")
    // if (item) {
    //     PostDataProductCategoryMaster(
    //         {
    //             productCaegoryID: item.id,
    //             productCategoryName: item.categoryName,
    //             UserID,
    //             flag: "Delete",
    //             handelClosePopUpClick: handelDeleteClosePopUpClick
    //         })
    // }
  };
  const handelDeleteClosePopUpClick = () => {
    setdeletePopUpShow(false);
    setdeleteRecord(null);
    // setflag("")
  };
  return (
    <>
      <div className="mt-2">
        <div className="container-scroller">
          <Navbar toggle={toggle} isopen={isopen} />
          <div className="container-fluid page-body-wrapper">

            <Siderbar isopen={isopen} />
            <div
              className="main-panel"
              style={{
                width: isopen ? "" : "calc(100%  - 116px )",
                marginLeft: isopen ? "" : "120px",
              }}
            >
              <main className="main-content position-relative border-radius-lg ">
                <div className="content-wrapper ">
                  <div className="row">
                    <div className="col-md-12 col-sm-12">
                      <div className="row page-heading col-12 col-lg-12 col-md-12 mb-xl-0  px-5 float-left">
                        <h4 className="font-weight-semi-bold "> Generated Members Id Card </h4>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 ">
                    <div className="card mb-4 overflow-hidden">
                      <div className="card-body px-4 py-2 linear-g">
                        <div className="row mb-4 px-2">
                          <div className="col-xl-4 col-lg-4 col-md-4">
                            <div className="form-group m-0">
                              <label>District</label>
                              <Select
                                isClearable
                                // isRtl={isRtl}
                                isSearchable
                              // value={{ value: customerNameDDL.ID, label: customerNameDDL.Label }}
                              // onChange={(e) => {
                              //     e ?
                              //         setcustomerNameDDL({ ...customerNameDDL, ID: e.value, Label: e.label })
                              //         :
                              //         setcustomerNameDDL({ ...customerNameDDL, ID: 0, Label: "Select..." })

                              // }}
                              // options={
                              //     customerNameDDL.DDL.map(item => ({
                              //         value: item.value,
                              //         label: item.label,

                              //     }))
                              // }
                              />
                            </div>
                          </div>
                          <div className="col-xl-4 col-lg-4 col-md-4">
                            <div className="form-group m-0">
                              <label>Taluka</label>
                              <Select
                                isClearable
                                // isRtl={isRtl}
                                isSearchable
                              // value={{ value: customerNameDDL.ID, label: customerNameDDL.Label }}
                              // onChange={(e) => {
                              //     e ?
                              //         setcustomerNameDDL({ ...customerNameDDL, ID: e.value, Label: e.label })
                              //         :
                              //         setcustomerNameDDL({ ...customerNameDDL, ID: 0, Label: "Select..." })

                              // }}
                              // options={
                              //     customerNameDDL.DDL.map(item => ({
                              //         value: item.value,
                              //         label: item.label,

                              //     }))
                              // }
                              />
                            </div>
                          </div>
                          <div className="col-xl-4 col-lg-4 col-md-4">
                            <div className="form-group m-0">
                              <label>Village</label>
                              <Select
                                isClearable
                                // isRtl={isRtl}
                                isSearchable
                              // value={{ value: customerNameDDL.ID, label: customerNameDDL.Label }}
                              // onChange={(e) => {
                              //     e ?
                              //         setcustomerNameDDL({ ...customerNameDDL, ID: e.value, Label: e.label })
                              //         :
                              //         setcustomerNameDDL({ ...customerNameDDL, ID: 0, Label: "Select..." })

                              // }}
                              // options={
                              //     customerNameDDL.DDL.map(item => ({
                              //         value: item.value,
                              //         label: item.label,

                              //     }))
                              // }
                              />
                            </div>
                          </div>
                          <div className="col-xl-4 col-lg-4 col-md-4">
                            <div className="form-group m-0">
                              <label>Member Name</label>
                              <Select
                                isClearable
                                // isRtl={isRtl}
                                isSearchable
                              // value={{ value: customerNameDDL.ID, label: customerNameDDL.Label }}
                              // onChange={(e) => {
                              //     e ?
                              //         setcustomerNameDDL({ ...customerNameDDL, ID: e.value, Label: e.label })
                              //         :
                              //         setcustomerNameDDL({ ...customerNameDDL, ID: 0, Label: "Select..." })

                              // }}
                              // options={
                              //     customerNameDDL.DDL.map(item => ({
                              //         value: item.value,
                              //         label: item.label,

                              //     }))
                              // }
                              />
                            </div>
                          </div>

                          <div className="col-xl-1 col-lg-1  ">
                            <div className="form-group   m-0 d-flex justify-content-center align-items-end h-100">
                              <button
                                type="button"
                                // onClick={handelClearClicked}
                                className="btn clear-btn mb-0"
                              >
                                Clear
                              </button>
                            </div>
                          </div>
                        </div>

                        {/* <TableData /> */}

                        <div
                          className="table-responsive p-0"
                        // ref={containerRef}
                        >
                          <table className="table table-bordered">
                            <thead>
                              <tr className="bg-gradient-dark text-white">
                                <th className=" w-6 v_sr_width">Sr. No.</th>
                                <th className=" ps-2">Registration No</th>
                                <th className=" ps-2">Member Name</th>
                                <th className=" ps-2">Village</th>
                                <th className=" ps-2">View</th>
                                {/* <th className=" ps-2 v_sr_width">Action</th> */}
                                <th className=" ps-2  w-10 v_sr_width">Download</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td align="center">1</td>
                                <td>Registration No</td>
                                <td>Member Name </td>
                                <td>Village</td>
                                <td>View</td>
                                {/* <td>Generate</td> */}

                                <td align="center">
                                  <i
                                    className="fa fa-file-pdf mx-2 v_icon_style"
                                    title="Edit"
                                    onClick={() => handleOnUpdateClick()}
                                  ></i>
                                  {/* <i
                                  className="fa fa-trash mx-2 text-danger cursor-pointer"
                                  onClick={() => {
                                    setdeletePopUpShow(true);
                                    // setdeleteRecord()
                                  }}
                                  title="Do you want to delete this record?"
                                ></i> */}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </main>
            </div>
          </div>
        </div>
      </div>

      {/* <FabAdd toggleState={showAddPopUp} settoggleState={handleOnAddClick} /> */}

      {showAddPopUp ? (
        <ApprovedPopUp
          handelClosePopUpClick={handelClosePopUpClick}
          popupflag={popupflag}
        />
      ) : (
        <></>
      )}

      {deletePopUpShow ? (
        <DeletePopUP
          heading="Member Card Generated"
          message={"Do you want to delete this record?"}
          cancelBtnCallBack={handelDeleteClosePopUpClick}
          confirmBtnCallBack={handelDeleteDesignation}
          deleteRecord={deleteRecord}
        />
      ) : (
        <></>
      )}
    </>
  );
}
